import React, { Component } from 'react';

class CellFormatter extends Component {
  render() {
    const { value } = this.props;
    return <span>{value || '-'}</span>;
  }
}

export default CellFormatter;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/cellFormatter.jsx